import {
  Cpu,
  Brain,
  Robot,
  Eye,
  Database,
  TreeStructure,
} from "@phosphor-icons/react";
import { subdomainImage } from "./utils";

const slug = "aiservices";

/** AI Services — aiservices.bizlem.com */
const aiservicesConfig = {
  slug,
  name: "AI Services",
  shortName: "AI Services",
  host: "aiservices.bizlem.com",
  icon: Cpu,
  theme: {
    primary: "bg-sky-600",
    primaryHover: "hover:bg-sky-700",
    primaryText: "text-sky-600",
    primaryBorder: "border-sky-600",
    tint: "bg-sky-50",
    heroGradient: "from-sky-800 via-sky-600 to-sky-500",
    cream: "bg-sky-50/40",
    badge: "bg-sky-50 border-sky-200 text-sky-700",
    ring: "ring-sky-100",
  },
  hero: {
    badge: "Enterprise AI & Generative Intelligence",
    headline: ["AI-First Architecture.", "Industrial-Grade Results."],
    highlightLine: 0,
    description:
      "Predictive analytics, computer vision, NLP, and generative AI engineered for industrial complexity — from strategy to production deployment.",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    ctaPrimary: "Request Demo",
    ctaSecondary: "Explore Solutions",
  },
  about: {
    label: "WHAT WE DO",
    heading: "Enabling enterprises with AI that delivers measurable outcomes",
    body: "From AI strategy and model development to MLOps and production deployment, our services team partners with heavy industry to embed intelligence into every workflow.",
  },
  modules: {
    label: "SERVICES",
    heading: "End-to-End AI Capabilities. One Trusted Partner.",
    body: "Every service is designed for industrial environments and works together — so strategy, development, deployment, and optimization run as one continuous engagement.",
    items: [
      { icon: Brain, title: "AI Strategy & Roadmap", body: "Assess readiness, identify high-value use cases, and build a phased AI transformation roadmap.", iconBg: "bg-sky-100 text-sky-700" },
      { icon: Robot, title: "Custom Model Development", body: "Build predictive, vision, and NLP models tailored to your domain data and operational constraints.", iconBg: "bg-violet-100 text-violet-700" },
      { icon: Eye, title: "Computer Vision", body: "Quality inspection, safety monitoring, and asset condition assessment using industrial-grade vision AI.", iconBg: "bg-amber-100 text-amber-700" },
      { icon: Database, title: "Data Engineering & MLOps", body: "Modern data pipelines, feature stores, and production ML infrastructure on cloud-native foundations.", iconBg: "bg-emerald-100 text-emerald-700" },
      { icon: Cpu, title: "Generative AI & Copilots", body: "Enterprise copilots, document intelligence, and generative workflows for operations and leadership.", iconBg: "bg-blue-100 text-blue-700" },
      { icon: TreeStructure, title: "AI Integration & Scale", body: "Embed AI into ERP, MES, SCADA, and existing enterprise systems with governed rollout.", iconBg: "bg-rose-100 text-rose-700" },
    ],
  },
  solutions: {
    label: "INDUSTRIES",
    heading: "AI services across heavy industry",
    items: [
      {
        title: "Manufacturing & Metals",
        points: ["Quality prediction models", "Predictive maintenance AI", "Production optimization", "Digital twin development"],
        image: "https://images.unsplash.com/photo-1761195696590-3490ea770aa1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      },
      {
        title: "Mining & Energy",
        points: ["Fleet optimization AI", "Safety analytics models", "Ore grade prediction", "Emissions forecasting"],
        image: subdomainImage(slug, "mining-energy-ai.png"),
      },
      {
        title: "Construction & Infrastructure",
        points: ["Project risk AI", "Schedule optimization", "Document intelligence", "Cost prediction models"],
        image: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      },
      {
        title: "Cross-Industry Platforms",
        points: ["Executive AI copilots", "Unified analytics platforms", "ESG intelligence", "Command center AI"],
        image: subdomainImage(slug, "cross-industry-platforms.png"),
      },
    ],
  },
  whyChoose: {
    label: "WHY CHOOSE US",
    heading: "Built for Scale. Designed for Simplicity.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    items: [
      "Deep industrial domain expertise across 20+ verticals",
      "Proven AI deployment methodology with measurable ROI",
      "Cloud-native MLOps for production-grade reliability",
      "End-to-end partnership from strategy to scale",
    ],
  },
  footerTagline:
    "Enterprise AI Services for Heavy Industry — from strategy and model development to production deployment and scale.",
  contactIndustry: "AI Services",
};

export default aiservicesConfig;
